var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-card',{staticClass:"mr-2"},[_c('div',[_vm._v("Forbidden access is denied")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }